import React, { useEffect, useState } from 'react'
import { GET_AMOUNT_FOR_SELECTED_PLAN } from '../../../../../graphql/query'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import { useMutation, useQuery } from '@apollo/client'
import {
  PAYMENT_GATEWAY_TO_UPDATE_PLAN,
  UPDATE_PLAN_FOR_BG_ACCOUNT
} from '../../../../../graphql/mutation'

interface IProps {
  closeModal: any
  isPaymentDetails: any
  selectedPackageId: any
  selectedPlanName: any
  selectedPlanCancel: any
  nextStep: any
  isProfile: boolean
}

const SelectedPlanAmount: React.FC<IProps> = ({
  closeModal,
  isPaymentDetails,
  selectedPackageId,
  selectedPlanName,
  selectedPlanCancel,
  nextStep,
  isProfile
}) => {
  const [showPaymentProcessing, setShowPaymentProcessing] = useState<Boolean>(false)
  const [progress, setProgress] = useState(0)
  const [stopProgressBar, setStopProgressBar] = useState<any>(false)
  const [invoiceNumber, setInvoiceNumber] = useState<string | null>(null)
  const [paymentCompleted, setPaymentCompleted] = useState(false)

  const { loading, error, data } = useQuery(GET_AMOUNT_FOR_SELECTED_PLAN, {
    variables: {
      input: {
        bgAccountId: isPaymentDetails.id,
        packageFeatureId: Number(selectedPackageId)
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': !isProfile ? 'Accounts' : 'Clients'
      }
    }
  })

  const [paymentGateWayToUpdatePlan] = useMutation(PAYMENT_GATEWAY_TO_UPDATE_PLAN, {
    context: {
      headers: {
        'access-control-allow-methods': !isProfile ? 'Accounts' : 'Clients'
      }
    }
  })

  const [updatePlanForBgAccount] = useMutation(UPDATE_PLAN_FOR_BG_ACCOUNT, {
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  useEffect(() => {
    if (stopProgressBar) {
      paymentGateWayToUpdatePlan({
        variables: {
          input: {
            bgAccountId: isPaymentDetails.id,
            packageFeatureId: Number(selectedPackageId),
            payingAmount: data?.getAmountForSelectedPlan?.data
          }
        }
      })
        .then((res: any) => {
          if (res.data) {
            setInvoiceNumber(res?.data?.paymentGatewayToUpdatePlan?.invoiceNumber)

            updatePlanForBgAccount({
              variables: {
                input: {
                  bgAccountId: isPaymentDetails.id,
                  packageFeatureId: Number(selectedPackageId),
                  invoiceNumber: String(res?.data?.paymentGatewayToUpdatePlan?.invoiceNumber)
                }
              }
            })
              .then((res: any) => {
                if (res.data) {
                  setPaymentCompleted(true)
                  setShowPaymentProcessing(false)
                } else {
                  setPaymentCompleted(false)
                }
              })
              .catch((err: any) => {
                setPaymentCompleted(false)
              })
          }
        })
        .catch((err: any) => {})
    }
  }, [
    stopProgressBar,
    isPaymentDetails.bgAccountId,
    selectedPackageId,
    data,
    paymentGateWayToUpdatePlan,
    updatePlanForBgAccount
  ])

  if (loading) {
    return <>Loading...</>
  }

  if (error) {
    console.log(error)
  }

  const showProcessing = () => {
    setShowPaymentProcessing(true)
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          setStopProgressBar(true)
          return 100
        } else {
          return prev + 10
        }
      })
    }, 500)
  }

  const handlerToClose = () => {
    console.log('working...')
    nextStep()
    closeModal()
    selectedPlanCancel()
  }

  //  render component
  let content

  if (showPaymentProcessing) {
    content = (
      <>
        <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Processing Payment</h1>
        <div className='flex-grow-1 card-rounded-bottom h-200px mh-200px my-5 mb-lg-12'>
          <div style={{ width: '200px', height: '300px', margin: '0 auto' }}>
            <CircularProgressbar
              value={progress}
              text={`${progress}%`}
              styles={buildStyles({
                pathColor: `rgba(60, 179, 113, ${progress / 100})`,
                textColor: '#000000',
                trailColor: '#d6d6d6',
                backgroundColor: '#3e98c7'
              })}
            />
          </div>
        </div>
        <h6 className='text-black text-center lh-lg mb-9'>Please Do Not Close This Page</h6>
      </>
    )
  } else if (paymentCompleted) {
    content = (
      <>
        <div className='text-center'>
          <i className='bi bi-check-circle-fill display-1 text-success'></i>
        </div>
        <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Payment Completed</h1>
        <h3 className='text-muted text-center lh-lg mb-9'>
          Your plan has been successfully changed to
          <h3 className='text-black'>{selectedPlanName}</h3>
        </h3>
        <h5 className='text-black text-center lh-lg mb-9'>Invoice Number: {invoiceNumber}</h5>
        <div className='text-center'>
          <button className='btn btn-primary' onClick={handlerToClose}>
            Ok
          </button>
        </div>
      </>
    )
  } else {
    content = (
      <>
        <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Plan Details</h1>

        <div className='d-flex align-items-center w-100 mt-4'>
          <label className='w-25 fw-bolder'>Selected Plan</label>
          <p className='mt-4'>{selectedPlanName}</p>
        </div>
        <div className='d-flex align-items-center w-100 mt-4'>
          <label className='w-25 fw-bolder'>Plan Amount</label>
          <p className='mt-4'>Rs {data?.getAmountForSelectedPlan?.data} ₹</p>
        </div>
        <div className='d-flex justify-content-end mt-2'>
          <p>
            <button className='btn btn-primary' onClick={showProcessing}>
              Confirm
            </button>
          </p>
        </div>
      </>
    )
  }

  return (
    <div className='d-flex flex-column w-100 mt-8'>
      <div>{content}</div>
    </div>
  )
}

export default SelectedPlanAmount
